import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

import { ApiResponse, Appointment } from "../models/appointment.model";

import { API_ENDPOINTS } from "./api/api-endpoints";
// ^ adjust ONLY this import path if your API_ENDPOINTS file
//   lives somewhere different relative to this service.

export interface CustomerAppointmentUpdateRequest {
  start_time?: string;
  service_ids?: string[];
  staff_id?: string | null;
  notes?: string;
}

export interface CancelAppointmentResponse {
  detail: string;
  appointment: Appointment;
}

@Injectable({
  providedIn: "root",
})
export class AppointmentsService {
  constructor(private http: HttpClient) {}

  getMyAppointments(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(
      API_ENDPOINTS.customer.appointments.list,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  getAppointmentByID(id: string): Observable<Appointment> {
    return this.http.get<Appointment>(
      API_ENDPOINTS.customer.appointments.detail(id),
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  updateAppointment(
    id: string,
    payload: CustomerAppointmentUpdateRequest,
  ): Observable<Appointment> {
    return this.http.patch<Appointment>(
      API_ENDPOINTS.customer.appointments.detail(id),
      payload,
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  cancelAppointment(id: string): Observable<CancelAppointmentResponse> {
    return this.http.delete<CancelAppointmentResponse>(
      API_ENDPOINTS.customer.appointments.detail(id),
      {
        headers: this.getAuthHeaders(),
      },
    );
  }

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem("access_token") || "";

    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    });
  }
}
